interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  note?: string;
}

export default function Pagination({ page, totalPages, onChange, note }: PaginationProps) {
  if (totalPages <= 1) {
    return note ? <p className="mt-8 text-center text-xs text-foreground-400">{note}</p> : null;
  }

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="mt-10 flex flex-col items-center gap-3">
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onChange(page - 1)}
          aria-label="上一页"
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        </button>
        {pages.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-label={`第 ${item} 页`}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 min-w-9 cursor-pointer rounded-md px-2 text-sm transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ))}
        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onChange(page + 1)}
          aria-label="下一页"
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </button>
      </div>
      <p className="text-xs text-foreground-400">
        第 {page} / {totalPages} 页{note ? ` · ${note}` : ""}
      </p>
    </div>
  );
}